import { render, staticRenderFns } from "./DocumentsLmListV1.vue?vue&type=template&id=abfe942a&scoped=true"
import script from "./DocumentsLmListV1.vue?vue&type=script&lang=js"
export * from "./DocumentsLmListV1.vue?vue&type=script&lang=js"
import style0 from "./DocumentsLmListV1.vue?vue&type=style&index=0&id=abfe942a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfe942a",
  null
  
)

export default component.exports